import { JSX } from 'react'

import { IconProps } from '../../icon'

const Download: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M38.7692 28.0513C38.0964 28.0513 37.5385 28.6092 37.5385 29.2821V34.2051C37.5385 35.3374 36.6195 36.2564 35.4872 36.2564H12.5128C11.3805 36.2564 10.4615 35.3374 10.4615 34.2051V29.2821C10.4615 28.6092 9.90359 28.0513 9.23077 28.0513C8.55795 28.0513 8 28.6092 8 29.2821V34.2051C8 36.6995 10.0185 38.718 12.5128 38.718H35.4872C37.9815 38.718 40 36.6995 40 34.2051V29.2821C40 28.6092 39.4421 28.0513 38.7692 28.0513Z'
      fill='black'
    />
    <path
      d='M23.1303 31.7928C23.3764 32.039 23.6882 32.1538 24 32.1538C24.3118 32.1538 24.6236 32.039 24.8697 31.7928L31.4338 25.2287C31.9097 24.7528 31.9097 23.9651 31.4338 23.4892C30.9579 23.0133 30.1703 23.0133 29.6944 23.4892L25.2308 27.9528V11.2308C25.2308 10.5579 24.6728 10 24 10C23.3272 10 22.7692 10.5579 22.7692 11.2308V27.9528L18.3056 23.4892C17.8297 23.0133 17.042 23.0133 16.5662 23.4892C16.0903 23.9651 16.0903 24.7528 16.5662 25.2287L23.1303 31.7928Z'
      fill='black'
    />
  </svg>
)

export default Download
